import { render, staticRenderFns } from "./AdvancedPlan.vue?vue&type=template&id=685ddc44&scoped=true"
import script from "./AdvancedPlan.vue?vue&type=script&lang=js"
export * from "./AdvancedPlan.vue?vue&type=script&lang=js"
import style0 from "./AdvancedPlan.vue?vue&type=style&index=0&id=685ddc44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685ddc44",
  null
  
)

export default component.exports